const Aux = props => props.children;
export default Aux;


// WEBPACK FOOTER //
// ./src/components/common/Aux/index.js